/**
 * relativeTime — lightweight relative-time formatter (no external dep).
 *
 * Returns strings like "just now", "2m ago", "3h ago", "4d ago".
 * Returns "—" for null/empty inputs.
 */
export function relativeTime(isoString: string | null | undefined): string {
  if (!isoString) return '—'
  const ms = Date.now() - new Date(isoString).getTime()
  if (ms < 0) return 'just now'
  const sec = Math.floor(ms / 1000)
  if (sec < 60) return 'just now'
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min}m ago`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`
  const day = Math.floor(hr / 24)
  return `${day}d ago`
}

/**
 * countdown — time remaining until a future ISO string.
 * Returns "expired", "Xs", "Xm Ys", "Xh Ym", etc.
 */
export function countdown(isoString: string | null | undefined): string {
  if (!isoString) return '—'
  const ms = new Date(isoString).getTime() - Date.now()
  if (ms <= 0) return 'expired'
  const sec = Math.floor(ms / 1000)
  if (sec < 60) return `${sec}s`
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min}m ${sec % 60}s`
  const hr = Math.floor(min / 60)
  return `${hr}h ${min % 60}m`
}
